/*
 * ATTENTION: An "eval-source-map" devtool has been used.
 * This devtool is neither made for production nor for readable output files.
 * It uses "eval()" calls to create a separate source file with attached SourceMaps in the browser devtools.
 * If you are trying to read the output file, select a different devtool (https://webpack.js.org/configuration/devtool/)
 * or disable the default devtool with "devtool: false".
 * If you are looking for production-ready output files, see mode: "production" (https://webpack.js.org/configuration/mode/).
 */
/******/ (function() { // webpackBootstrap
/******/ 	"use strict";
/******/ 	var __webpack_modules__ = ({

/***/ "./src/scripts/sections/page-reviews.js":
/*!**********************************************!*\
  !*** ./src/scripts/sections/page-reviews.js ***!
  \**********************************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

eval("__webpack_require__.r(__webpack_exports__);\n/* harmony import */ var _styles_sections_page_reviews_scss__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/styles/sections/page-reviews.scss */ \"./src/styles/sections/page-reviews.scss\");\n\n\n/* Move yotpo label next to star ratings */\nwindow.addEventListener('load', () => {\n  const yotpoLabel = document.querySelector('.yotpo-label-container');\n  const starsContainer = document.querySelector('.rating-stars-container');\n  starsContainer.append(yotpoLabel);\n});//# sourceURL=[module]\n//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiLi9zcmMvc2NyaXB0cy9zZWN0aW9ucy9wYWdlLXJldmlld3MuanMiLCJtYXBwaW5ncyI6Ijs7QUFBNkM7O0FBRTdDO0FBQ0FBLE1BQU0sQ0FBQ0MsZ0JBQWdCLENBQUMsTUFBTSxFQUFFLE1BQU07RUFDcEMsTUFBTUMsVUFBVSxHQUFHQyxRQUFRLENBQUNDLGFBQWEsQ0FBQyx3QkFBd0IsQ0FBQztFQUNuRSxNQUFNQyxjQUFjLEdBQUdGLFFBQVEsQ0FBQ0MsYUFBYSxDQUFDLHlCQUF5QixDQUFDO0VBRXhFQyxjQUFjLENBQUNDLE1BQU0sQ0FBQ0osVUFBVSxDQUFDO0FBQ25DLENBQUMsQ0FBQyIsInNvdXJjZXMiOlsid2VicGFjazovL3Nob3BpZnktYm9pbGVycGxhdGUvLi9zcmMvc2NyaXB0cy9zZWN0aW9ucy9wYWdlLXJldmlld3MuanM/NGM4MSJdLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgJ0Avc3R5bGVzL3NlY3Rpb25zL3BhZ2UtcmV2aWV3cy5zY3NzJztcblxuLyogTW92ZSB5b3RwbyBsYWJlbCBuZXh0IHRvIHN0YXIgcmF0aW5ncyAqL1xud2luZG93LmFkZEV2ZW50TGlzdGVuZXIoJ2xvYWQnLCAoKSA9PiB7XG4gIGNvbnN0IHlvdHBvTGFiZWwgPSBkb2N1bWVudC5xdWVyeVNlbGVjdG9yKCcueW90cG8tbGFiZWwtY29udGFpbmVyJyk7XG4gIGNvbnN0IHN0YXJzQ29udGFpbmVyID0gZG9jdW1lbnQucXVlcnlTZWxlY3RvcignLnJhdGluZy1zdGFycy1jb250YWluZXInKTtcblxuICBzdGFyc0NvbnRhaW5lci5hcHBlbmQoeW90cG9MYWJlbCk7XG59KTtcbiJdLCJuYW1lcyI6WyJ3aW5kb3ciLCJhZGRFdmVudExpc3RlbmVyIiwieW90cG9MYWJlbCIsImRvY3VtZW50IiwicXVlcnlTZWxlY3RvciIsInN0YXJzQ29udGFpbmVyIiwiYXBwZW5kIl0sInNvdXJjZVJvb3QiOiIifQ==\n//# sourceURL=webpack-internal:///./src/scripts/sections/page-reviews.js\n");

/***/ }),

/***/ "./src/styles/sections/page-reviews.scss":
/*!***********************************************!*\
  !*** ./src/styles/sections/page-reviews.scss ***!
  \***********************************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

eval("__webpack_require__.r(__webpack_exports__);\n// extracted by mini-css-extract-plugin\n//# sourceURL=[module]\n//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiLi9zcmMvc3R5bGVzL3NlY3Rpb25zL3BhZ2UtcmV2aWV3cy5zY3NzIiwibWFwcGluZ3MiOiI7QUFBQSIsInNvdXJjZXMiOlsid2VicGFjazovL3Nob3BpZnktYm9pbGVycGxhdGUvLi9zcmMvc3R5bGVzL3NlY3Rpb25zL3BhZ2UtcmV2aWV3cy5zY3NzPzc5YjMiXSwic291cmNlc0NvbnRlbnQiOlsiLy8gZXh0cmFjdGVkIGJ5IG1pbmktY3NzLWV4dHJhY3QtcGx1Z2luXG5leHBvcnQge307Il0sIm5hbWVzIjpbXSwic291cmNlUm9vdCI6IiJ9\n//# sourceURL=webpack-internal:///./src/styles/sections/page-reviews.scss\n");

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	!function() {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = function(exports) {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	}();
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module can't be inlined because the eval-source-map devtool is used.
/******/ 	var __webpack_exports__ = __webpack_require__("./src/scripts/sections/page-reviews.js");
/******/ 	
/******/ })()
;